import { compose } from 'react-apollo';
import { gql } from '@apollo/client';
import { graphql } from '@apollo/client/react/hoc';

import CallbacksList from './CallbacksList.js';

export default compose(
  graphql(gql`query {
    callbacks {
      json,
    }
  }`, {
    options: {
      pollInterval: 10000
    },
  }),
)(CallbacksList);